import React from 'react';
import { ArticleCard } from '../components/ArticleCard';
import { Article } from '../types';

interface ArticlesPageProps {
  articles: Article[];
  onArticleClick: (article: Article) => void;
}

export const ArticlesPage: React.FC<ArticlesPageProps> = ({ articles, onArticleClick }) => (
  <div>
    <h2 className="text-6xl md:text-7xl lg:text-8xl font-display font-black mb-20 text-gray-900 uppercase tracking-tighter">
      Kaikki Uutiset
    </h2>
    {articles.length > 0 ? (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
        {articles.map(article => (
          <ArticleCard
            key={article.id}
            article={article}
            onClick={() => onArticleClick(article)}
          />
        ))}
      </div>
    ) : (
      <p className="text-gray-700 text-xl font-headline font-bold">Uutisia ei löytynyt.</p>
    )}
  </div>
);